// @flow

import styled from '@emotion/styled'
import * as React from 'react'

import { media } from '@toggl/style'

import * as text from '../text'

type Props = {|
  image: React.Node,
  title: string,
  paragraph: string | React.Node,
|}

export function Feature({ image, title, paragraph }: Props) {
  return (
    <Root>
      <ImageWrapper>{image}</ImageWrapper>
      <TextSection>
        <Title>{title}</Title>
        <Paragraph>{paragraph}</Paragraph>
      </TextSection>
    </Root>
  )
}

export const Features: React.ComponentType<any> = styled.div`
  padding-top: 60px;

  ${media.mq[1]} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 60px;
    padding-top: 100px;
  }
`
export const FeaturesWrapper: React.ComponentType<any> = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5 {
    color: ${(p) => p.theme.primary};
  }

  > h1,
  > h2,
  > h3,
  > h4,
  > h5 {
    text-align: center;
    ${media.mq[1]} {
      margin-bottom: 15px;
    }
  }
`

const ImageWrapper = styled.div`
  img {
    width: 100%;
    height: auto;
  }
`

const Paragraph = styled(text.P3)`
  margin-top: 8px;
`

const TextSection = styled.div`
  margin: 20px 0 30px;
  padding-bottom: 25px;
`

const Title = styled(text.H4)`
  color: ${(p) => p.theme.primary};
  margin: 8px 0 5px;
`

const Root: React.ComponentType<any> = styled.div`
  display: flex;
  flex-direction: column;
  ${media.mq[1]} {
    max-width: 466px;
    &:nth-of-type(2n) {
      margin-top: 80px;
    }
  }
`
